import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=4ce58848&scoped=true"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=4ce58848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce58848",
  null
  
)

export default component.exports